import {appConstants} from '../_constants';
import {initialState} from "../_store";

export function dashboard(state=initialState.dashboard, action) {
    switch (action.type) {
        case appConstants.ADD_DASHBOARD:
            return Object.assign({}, state, action.data);
        default:
            return state
      }
}



// WEBPACK FOOTER //
// ./src/_reducers/dashboard.reducer.js